import { Component, OnInit } from '@angular/core'
import { UserService } from '@service/user/user.service'
import { AdvertService } from '@service/advert/advert.service'
import { ToastService } from '@service/toast/toast.service'
import { UrlPrettifierService } from '@service/urlPrettifier/url-prettifier.service'
import { Advert } from '@model/entities/advert'
import { MatDialog } from '@angular/material/dialog';
import { ScrollService } from '@service/scroll.service';
import { TransitionHookService } from '@service/transition-hook.service';
import { MobileService } from '@service/mobile.service';
import { EntityCreateComponent } from '@component/entity-create-component'
import { EntityTypeIdentifier } from '@type/entity-type-identifier';
import { EntityTypeConfigService } from '@service/entity-type-config.service'
import { LoadingService } from '@service/loading.service'
import { HelperService } from '@service/helper.service'
import { environment } from '@environments/environment'
import { ImageKeys } from '@type/image-keys'
import { StateService } from '@service/state.service'
import { ActivatedRoute, Router } from '@angular/router'

@Component({
  selector: 'app-create-advert',
  templateUrl: './advert-create.component.html',
  styleUrls: ['./advert-create.component.scss'],
})
export class AdvertCreateComponent extends EntityCreateComponent implements OnInit {

  protected entityTypeIdentifier: EntityTypeIdentifier = "advert"

  // draft
  public draft: Advert = new Advert()

  public mostViewed: Advert[] = []

  public mainImageDeleted = false;

  constructor(
    public userService: UserService,
    private advertService: AdvertService,
    protected toastService: ToastService,
    protected LoadingService: LoadingService,
    protected transitionHookService: TransitionHookService,
    protected dialog: MatDialog,
    protected scrollService: ScrollService,
    public mobileService: MobileService,
    public entityTypeConfigService: EntityTypeConfigService,
    public Mobileservice: MobileService,
    protected HelperService: HelperService,
    public StateService: StateService,
    public ActivatedRoute: ActivatedRoute,
    public Router: Router
  ) {
    super(
      entityTypeConfigService,
      scrollService,
      userService,
      LoadingService,
      HelperService,
      transitionHookService,
      dialog,
      toastService,
      StateService,
      ActivatedRoute,
      Router
    )
  }

  public ngOnInit() {

    super.ngOnInit()

    // get mostviewed
    this.advertService.getMostViewed()
      .then(mostViewed => {
        this.mostViewed = mostViewed
      })
      
  }

  public override nextIfFormValid(shadowUpdate: boolean = true, fieldsToControl?: string[]) {
    this.formSubmitted = true

    // Der Check, ob ein Bild gelöscht wurde und keines mehr vorhanden ist
    if (this.mainImageDeleted && !this.draft.mainImage) {
        this.toastService.showError('Bitte laden Sie ein Hauptbild hoch.')
        return
    }

    // Optional: Restliche Logik der Basisklasse aufrufen
    super.nextIfFormValid(shadowUpdate, fieldsToControl)
  }

  // @Overwrite
  protected customPostUpdate() {
    this.updateSelectedPriceMode()
  }

  public onLocationSelected($event: any) {
    this.onAutocompleteSelected($event);
    this.updateDraft()
  }

  public onAutocompleteSelected($event: any) {

    if (!$event.address_components)
      return

    for (const cityDef of $event.address_components) {
      if (cityDef.types.includes('locality')) {
        this.form.controls.city.setValue(cityDef.long_name)
      }
      if (cityDef.types.includes('postal_code')) {
        this.form.controls.zip.setValue(parseInt(cityDef.long_name))
      }
    }
  }

  public updateSelectedPriceMode() {

    if (!environment.production)
      console.log("updateSelectedPriceMode", `price_mode: ${this.form.controls.price_mode.value}`)

    let control = this.form.controls.price

    if (this.form.controls.price_mode.value == "PRICE_ON_REQUEST") {
      this.draft.price = null
      this.form.controls.price.setValue(null)
      control.disable()
    }
    else {
      control.enable()
    }
  }

  public deleteImage(imageId: number, key: ImageKeys): Promise<void> {
    
    if(imageId == -1){
      this.mainImageDeleted  =true;
      this.draft.mainImage = null
        this.draft.galleryImages = []
        this.draft.images = []
        
        this.form.errors["mainImage_required"] = true
        this.form
      return new Promise((resolve, reject) => {})
    }

    return new Promise((resolve, reject) => {
      this.LoadingService.startLoad()

      this.advertService.deleteImage(this.draft.id, imageId)
        .then((draft: Advert) => {
          this.draft = draft
          this.form.patchValue({
            mainImage: this.draft.mainImage
          })
        })
        .finally(() => {
          this.LoadingService.stopLoad()
        })
    })
  }

  public gotoDetail() {
    this.scrollService.scrollToTop()

    this.StateService.goto('/market/detail/' + this.draft.id + "/" + UrlPrettifierService.prettyUrl(this.draft.title))

    this.toastService.showSuccess("Deine Anzeige wurde gespeichert.")
  }

  /*
  *   @implement
  */
  protected calcStateVars() { }

  /*
  *   @override
  *
  *   This method is executed every time the form group gets initiated and its an edit
  */
  public customEditActions() {
    // disable profile_type
    this.form.controls.profile_type.disable()

    // disable sale_type
    this.form.controls.sale_type.disable()
  }
}
